import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Form from 'react-jsonschema-form';
import { Button } from 'react-bootstrap';
import { getUserSchema, getEmployeeSchema, uiSchema } from './Schema';
import PhoneInputField from './PhoneInputField';
import './UserEditor.scss';
import validate from './validations';
import transformErrors from './utils';

export default class NewUser extends PureComponent {
  onSubmit = ({ formData }) => {
    this.props.onCreate(formData);
  };

  render() {
    const { fetching, user, dealer, accessibleRoles, isEmployeeRoute } =
      this.props;

    const schema = isEmployeeRoute
      ? getEmployeeSchema({ user, accessibleRoles })
      : getUserSchema({ user, dealer, accessibleRoles });

    return (
      <div className="dealer-list-container">
        <Form
          schema={schema}
          uiSchema={uiSchema}
          formData={user}
          fields={{ phone: PhoneInputField }}
          validate={validate}
          transformErrors={transformErrors}
          onSubmit={this.onSubmit}
        >
          <Button
            bsClass="btn btn-primary btn-large"
            disabled={fetching}
            type="submit"
          >
            Submit
          </Button>
        </Form>
      </div>
    );
  }
}

NewUser.propTypes = {
  fetching: PropTypes.bool,
  user: PropTypes.object,
  dealer: PropTypes.object,
  onCreate: PropTypes.func,
  accessibleRoles: PropTypes.array,
  isEmployeeRoute: PropTypes.bool,
};
